export default __webpack_public_path__ + "static/media/image-activity-card-white-background.2a4f6913.svg";